// extracted by mini-css-extract-plugin
export var root = "rich-text-kahoot-module--root--a054f";